import api from './api';

const AUTH_PARAMS = {
  params: {
    token: process.env.ICLINIC_API_AUTH_TOKEN,
  },
};

export const loginWithEmail = (
  email: string,
  password: string,
  captcha: string,
) =>
  api.post(
    '/accounts/user/login/secure/',
    {
      username: email,
      password,
      captcha,
      is_mobile: !!window.mobileWebview,
      ...(window.mobileWebview && {
        platform: window.mobileWebview.Constants.platform,
      }),
      ...(window.mobileWebview && {
        installation_id: window.mobileWebview.Constants.installationId,
      }),
    },
    {
      ...AUTH_PARAMS,
    },
  );

export const loginWithGoogle = (token: string) =>
  api.post(
    '/accounts/user/login/social/google/',
    {
      access_token: token,
    },
    {
      ...AUTH_PARAMS,
    },
  );

export const loginWithECPF = (email: string) =>
  api.post(
    '/accounts/user/login/ecpf/',
    {
      email,
    },
    {
      ...AUTH_PARAMS,
    },
  );

export const validateECPF = (taskID: string) =>
  api.get('/accounts/user/login/ecpf-webapp/', {
    params: {
      ...AUTH_PARAMS.params,
      task_id: taskID,
    },
  });

export const sendPasswordResetEmail = (email: string, token: string) => {
  return api.post(
    '/accounts/user/password/forget/',
    {
      email,
    },
    {
      params: {
        token,
      },
    },
  );
};

export const getAuthToken = () => process.env.ICLINIC_API_AUTH_TOKEN;

const passwordResetPath = '/accounts/user/password/reset/';

export const sendNewPassword = (
  uidb36: string,
  passToken: string,
  newPassword: string,
  token: string,
) => {
  return api.post(
    passwordResetPath,
    {
      new_password1: newPassword,
      new_password2: newPassword,
    },
    {
      params: {
        token,
        uidb36,
        pass_token: passToken,
        auto_login: 'true',
      },
    },
  );
};

export const checkPasswordLink = (uidb36: string, passToken: string) => {
  return api.get<{ validlink: boolean }>(passwordResetPath, {
    params: {
      uidb36,
      pass_token: passToken,
    },
  });
};

export const validateToken = (token: string) =>
  api.get(`/icapi/ticket/validate/?token=${token}`);
